import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count", "error"]
  static values = { max: Number, html: Boolean }

  connect() {
    this.update()
  }

  update() {
    const length = this.text().length

    if (this.hasCountTarget) this.countTarget.textContent = length
    if (this.hasErrorTarget) this.errorTarget.classList.toggle("tw-hidden", length <= this.maxValue)
  }

  text() {
    const content = this.inputTarget.value ?? this.inputTarget.innerText

    return this.htmlValue ? new DOMParser().parseFromString(content, "text/html").body.textContent : content
  }
}
